import { render, staticRenderFns } from "./CRC.vue?vue&type=template&id=72648b2c&scoped=true&"
import script from "./CRC.vue?vue&type=script&lang=js&"
export * from "./CRC.vue?vue&type=script&lang=js&"
import style0 from "./CRC.vue?vue&type=style&index=0&id=72648b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72648b2c",
  null
  
)

export default component.exports